import PropTypes from 'prop-types'
import styled from 'styled-components'
import Image from 'next/image'

import { FadeUp } from '@happymoneyinc/move'

import Container from './Container'
import Display from './Display'
import Headline from './Headline'
import Text from './Text'

const Values = (props) => {
  const {
    eyebrow,
    headline,
    headlineSize,
    subtext,
    subtextSize,
    items,
    valueHeadlineMb,
    keepTitleDesktop
  } = props

  return (
    <Wrapper center>
      <StyledFadeUp>
        <TextWrapper>
          <Eyebrow size="eyebrow">{eyebrow}</Eyebrow>
          <StyledDisplay size={headlineSize} element="h2" keepTitleDesktop={keepTitleDesktop}>{headline}</StyledDisplay>
          <Subtext size={subtextSize}>{subtext}</Subtext>
        </TextWrapper>
        <Inner>
          {items.map((item, index) => (
            <Value key={item.text}>
              <ImageWrapper>
                <Image alt={item.image.alt} src={item.image.url} width={240} height={240} />
              </ImageWrapper>
              <ValueHeadline size="medium" mb={valueHeadlineMb}>{item.text}</ValueHeadline>
              <ValueText>{item.subtext}</ValueText>
            </Value>
          ))}
        </Inner>
      </StyledFadeUp>
    </Wrapper>
  )
}

const Eyebrow = styled(Text)`
  margin: 0;
  text-transform: uppercase;
`

const StyledDisplay = styled(Display)`
  margin: 32px auto;
  white-space: break-spaces;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.sm }) {
    white-space: ${ ({ keepTitleDesktop }) => (keepTitleDesktop ? 'initial' : 'break-spaces') };
  }
`

const Subtext = styled(Headline)`
  margin-top: 0;
`

const ImageWrapper = styled.div`
  width: 160px;

  @media screen and (min-width: ${ ({ theme }) => theme.breakpoints.sm }) {
    width: 240px;
  }
`

const Value = styled.div`
  align-items: center;
  flex-direction: column;
  display: flex;
  text-align: center;
`

const StyledFadeUp = styled(FadeUp)`
  align-items: center;
  flex-direction: column;
  display: flex;
`

const ValueHeadline = styled(Headline)`
  margin-bottom: ${ ({ mb }) => mb };
`

const ValueText = styled(Text)`
  max-width: 280px;
  margin: 0;
`

const Inner = styled.div`
  display: grid;
  width: 100%;
  margin-top: 80px;
  grid-gap: 100px;

  @media screen and (min-width: ${ (props) => props.theme.breakpoints.md }) {
    margin-top: 100px;
    grid-template-columns: repeat(3, 1fr);
  }
`

const TextWrapper = styled.div`
  max-width: 666px;
`

const Wrapper = styled(Container)`
  text-align: center;
  background-color: ${ ({ theme }) => theme.colors.flamingo[3] };

  .detect-wrapper {
    width: 100%;
  }
`

Values.defaultProps = {
  headlineSize: 'medium',
  subtextSize: 'medium',
  valueHeadlineMb: '18px',
  keepTitleDesktop: false,
}

Values.propTypes = {
  eyebrow: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  headlineSize: PropTypes.string,
  subtext: PropTypes.string.isRequired,
  subtextSize: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  valueHeadlineMb: PropTypes.string,
  keepTitleDesktop: PropTypes.bool,
}

export default Values
